import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export function useNavigationHistory(limit = 10) {
  const location = useLocation();
  const navigate = useNavigate();
  const historyRef = useRef([]);

  useEffect(() => {
    const current = location.pathname + location.search;

    const last = historyRef.current[historyRef.current.length - 1];

    if (current !== last) {
      historyRef.current.push(current);
      if (historyRef.current.length > limit) {
        historyRef.current.shift();
      }
    }
  }, [location]);

  const goBack = () => {
    if (historyRef.current.length >= 2) {
      // Remove current location
      historyRef.current.pop();
      const previous = historyRef.current[historyRef.current.length - 1];
      navigate(previous);
    } else {
      navigate('/'); // fallback route
    }
  };

  return {
    history: historyRef.current,
    previous:
      historyRef.current.length >= 2
        ? historyRef.current[historyRef.current.length - 2]
        : null,
    goBack,
  };
}
